import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginContainer from "./modules/auth/container/LoginContainer";
import AccessControl from "./modules/auth/component/AccessControl";
import ChatInterfaceContainer from "./modules/chat/container/ChatInterfaceContainer";
import TaskBoardContainer from "./modules/task/container/TaskBoardContainer";
import TaskNotifications from "./modules/chat/component/Notification";
import "./assets/css/layout/layout.scss";
import UserListContainer from "./modules/users/container/UserListContainer";
import SitesListContainer from "./modules/sites/container/UserListContainer";
import SiteGroupListContainer from "./modules/siteGroup/container/SiteGroupListContainer";
import PropConfigListContainer from "./modules/propConfig/container/PropConfigListContainer";
import PropContainerDetailContainer from "./modules/propConfig/container/PropConfigDetailContainer";
import TaskNotificationListContainer from "./modules/taskNotification/container/TaskNotificationListContainer";

const AuthRequiredContainer = () => {
    return (
        <>
            <AccessControl>
                {/* <NotificationContainer> */}
                <Routes>
                    <Route path="/task" element={<TaskBoardContainer />} /> 
                    <Route path="/chat-interface" element={<ChatInterfaceContainer />} />
                    <Route path="/check" element={<TaskNotifications />} /> 
                    <Route path="/users" element={<UserListContainer />} /> 
                    <Route path="/sites" element={<SitesListContainer />} /> 
                    <Route path="/site-group" element={<SiteGroupListContainer />} /> 
                    <Route path="/prop-confg" element={<PropConfigListContainer />}/>
                    <Route path="/prop-confg/detail" element={<PropContainerDetailContainer />} />
                    <Route path="/task-notification" element={<TaskNotificationListContainer />} />
                </Routes>
                {/* </NotificationContainer> */}
                
            </AccessControl>
        </>
    )
}

const AppRoutes = () => (
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<LoginContainer />} />
            <Route element={<AuthRequiredContainer />} path='/ui/*' />
        </Routes>
    </BrowserRouter>
);


export default AppRoutes;
